<div class="loader-wrapper" *ngIf="loaderService.isLoaderVisible | async">
	<i nz-icon nzType="loading" [nzSpin]="true"></i>
</div>
